import EFPicture from 'elem/compCommon/EFPicture';
import EfLink from 'elem/ui/ef-link';
import { FormatMoneyLocal } from '@elem/ui-common/utils/FormatMoneyLocal';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function E({ ICON_AMAZON }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('amazonsale');
    const productList = [
        {
            key: 'product1',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724049524899/amazon_sale_e_product1.png',
            title: t('sectionE_product_1_title'),
            price: 33180,
            original_price: 47400,
            link: 'https://www.amazon.co.jp/dp/B0DB5XKTJV',
        },
        {
            key: 'product2',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724049524715/amazon_sale_e_product2.png',
            title: t('sectionE_product_2_title'),
            price: 115500,
            original_price: 192500,
            link: 'https://www.amazon.co.jp/dp/B0DB5WZC15?ref=myi_title_dp',
        },
        {
            key: 'product3',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724049524542/amazon_sale_e_product3.png',
            title: t('sectionE_product_3_title'),
            price: 172545,
            original_price: 313720,
            link: 'https://www.amazon.co.jp/dp/B0C375KH58?ref=myi_title_dp',
        },
        {
            key: 'product4',
            img: 'https://websiteoss.ecoflow.com/upload/image/1724049525252/amazon_sale_e_product4.png',
            title: t('sectionE_product_4_title'),
            price: 419634,
            original_price: 645590,
            link: 'https://www.amazon.co.jp/dp/B0D543NBFH?ref=myi_title_dp',
        },
    ];

    return (
        <div id="amazon-sale-E" className={`amazon-sale-E ${css['amazon-sale-E']}`}>
            <div className="section-content">
                <p className="title">{t('sectionE_title')}</p>
                <div className="product-content">
                    {productList.map((item) => (
                        <div className="product" key={item.key}>
                            <div className="off">
                                <EFPicture
                                    className="off-icon"
                                    src="https://websiteoss.ecoflow.com/upload/image/1724050596684/amazon_sale_e_off.png"
                                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1724050596684/amazon_sale_e_off.png"
                                    alt={t('sectionE_title')}
                                />
                                <p className="off-text">{Math.round((1 - item.price / item.original_price) * 100) || 0}%</p>
                            </div>
                            <EFPicture className="product-img" src={item.img} srcMobile={item.img} alt={t('sectionE_title')} />
                            <p className="product-title">{item.title}</p>
                            <p className="price">
                                {FormatMoneyLocal(item.price, 'jp')}
                                <span className="suffix">{t('price_suffix')}</span>
                            </p>
                            <p className="original-price">
                                {t('price_text')}
                                {FormatMoneyLocal(item.original_price, 'jp')}
                                {t('price_suffix')}
                            </p>
                            <EfLink
                                href={item.link}
                                className="amazon-btn"
                                dataLayer={[
                                    {
                                        event: 'uaEvent',
                                        event_name: 'buy_on_amazon',
                                        product_name: item.title,
                                        button_name: `${t('amazon_btn')}_Amazon Product Details Page`,
                                        list_name: t('sectionE_title'),
                                    },
                                ]}
                            >
                                <ICON_AMAZON />
                                {t('amazon_btn')}
                            </EfLink>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
